(function () {
  'use strict';

  // ── Gallery ─────────────────────────────────────────────────────
  const gallery = document.querySelector('[data-pe-gallery]');
  if (gallery) {
    const slides   = gallery.querySelectorAll('[data-pe-slide]');
    const thumbs   = gallery.querySelectorAll('[data-pe-thumb]');
    const caption  = gallery.querySelector('[data-pe-caption]');
    const frame    = gallery.querySelector('[data-pe-frame]');
    const thumbFrame = gallery.querySelector('[data-pe-thumb-frame]');

    let active = 0;
    let isFramed = false;

    function setActive(i) {
      active = i;
      slides.forEach((s, idx) => s.classList.toggle('is-active', idx === i));
      thumbs.forEach((t, idx) => t.classList.toggle('is-active', idx === i));

      // Caption: only show for non-first (in-situ) images
      if (caption) {
        const label = slides[i] && slides[i].getAttribute('data-pe-label');
        if (i > 0 && label) { caption.hidden = false; caption.textContent = label; }
        else                { caption.hidden = true;  caption.textContent = ''; }
      }

      updateFrame();
    }

    function updateFrame() {
      // Framed-overlay UI removed — the Framed finish is communicated
      // through the variant selector + the framing note + the framing
      // tab below, not via an oak-frame decoration on the hero image.
      // Function kept as a no-op so the existing event handlers below
      // don't blow up.
    }

    thumbs.forEach((t, idx) => {
      t.addEventListener('click', () => setActive(idx));
    });

    // Expose finish state to gallery
    window.__peSetFinish = (framed) => {
      isFramed = framed;
      if (framed) setActive(0); else updateFrame();
    };
  }

  // ── Option selectors (highlight + variant resolve) ──────────────
  const form = document.querySelector('[data-pe-form]');
  if (form) {
    const productJson = document.querySelector('[data-pe-product-json]');
    let product = null;
    try { product = productJson ? JSON.parse(productJson.textContent) : null; } catch (e) {}

    const priceEl = document.querySelector('[data-pe-price]');
    const variantInput = document.querySelector('[data-pe-variant-id]');
    const framingNote  = document.querySelector('[data-pe-framing-note]');

    function activeOptionLabels() {
      // Update visual .is-active state on each option
      const opts = {};
      form.querySelectorAll('input[type="radio"]').forEach((input) => {
        const label = input.closest('.pe-option');
        if (!label) return;
        label.classList.toggle('is-active', input.checked);
        if (input.checked) opts[input.name] = input.value;
      });
      return opts;
    }

    function resolveVariant(opts) {
      if (!product) return null;
      const optionNames = product.options.map((o) => (typeof o === 'string' ? o : o.name));
      const wanted = optionNames.map((n) => opts['options[' + n + ']']);
      return product.variants.find((v) => {
        return wanted.every((val, i) => !val || val === v['option' + (i + 1)]);
      });
    }

    function formatMoney(cents) {
      const dollars = (cents / 100).toFixed(2).replace(/\.00$/, '');
      return '$' + dollars;
    }

    function handleChange() {
      const opts = activeOptionLabels();

      // Framed/Unframed: drive gallery overlay
      const finishVal = (opts['options[Finish]'] || opts['finish'] || '').toLowerCase();
      const isFramed = finishVal === 'framed';
      if (typeof window.__peSetFinish === 'function') window.__peSetFinish(isFramed);
      if (framingNote) framingNote.hidden = !isFramed;

      // Variant + price + remaining
      const variant = resolveVariant(opts);
      if (variant) {
        if (variantInput) variantInput.value = variant.id;
        if (priceEl)      priceEl.textContent = formatMoney(variant.price);

        const remainingEl = document.querySelector('[data-pe-remaining]');
        if (remainingEl && typeof variant.inventory_quantity === 'number') {
          remainingEl.textContent = Math.max(0, variant.inventory_quantity);
        }
      }
    }

    form.addEventListener('change', handleChange);
    // Click on the label itself (not the radio) — make sure visual state stays in sync
    form.addEventListener('click', (e) => {
      const label = e.target.closest('.pe-option');
      if (label) {
        const input = label.querySelector('input[type="radio"]');
        if (input && !input.checked) {
          input.checked = true;
          handleChange();
        }
      }
    });

    handleChange();

    // ── Reserve CTA feedback ──────────────────────────────────────
    const cta = document.querySelector('[data-pe-cta]');
    const ctaLabel = document.querySelector('[data-pe-cta-label]');
    if (cta && ctaLabel) {
      cta.addEventListener('click', (e) => {
        // If product isn't a real Shopify product (no variant id), prevent submit
        if (!variantInput || !variantInput.value) {
          e.preventDefault();
        }
        const original = ctaLabel.textContent;
        cta.classList.add('is-added');
        ctaLabel.textContent = '✓  Reserved';
        setTimeout(() => {
          cta.classList.remove('is-added');
          ctaLabel.textContent = original;
        }, 2400);
      });
    }
  }

  // ── Tabs ────────────────────────────────────────────────────────
  const tabs = document.querySelector('[data-pe-tabs]');
  if (tabs) {
    const btns   = tabs.querySelectorAll('[data-pe-tab]');
    const panels = tabs.querySelectorAll('[data-pe-tab-panel]');
    btns.forEach((b) => {
      b.addEventListener('click', () => {
        const key = b.getAttribute('data-pe-tab');
        btns.forEach((x) => {
          const active = x === b;
          x.classList.toggle('is-active', active);
          x.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((p) => {
          p.classList.toggle('is-active', p.getAttribute('data-pe-tab-panel') === key);
        });
      });
    });
  }
})();
